





































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Surface, Typography } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';

import CoinSettings from '@/components/organisms/Offers/DataPresentation/CoinSettings.vue';
import BirthdayCoinSettings from '@/components/organisms/Offers/DataPresentation/BirthdayCoinSettings.vue';
import ImageSpecialCoinPreview from '@/components/organisms/Offers/ImageSpecialCoinPreview.vue';
import TagBirthday from '@/components/organisms/Offers/DataPresentation/TagBirthday.vue';

import SpecialCoinOfferImage from '@/components/icons/SpecialCoinOfferImage.vue';
import ExternalLink from '@/components/icons/ExternalLink.vue';
import DiscountOffer from '@/components/molecules/DiscountOffer/DiscountOffer.vue';
import { SpecialOfferTypeEnum } from '@/models/offer';
import TagSpecialCoin from '@/componentsV2/atoms/TagSpecialCoin/TagSpecialCoin.vue';
import { ILocation } from '@/models/location';
import OfferTypeTag from '@/components/molecules/OfferTypeTag/OfferTypeTag.vue';
import OfferImageUploadCreation from '@/componentsV2/molecules/Inputs/OfferImageUploadCreation.vue';
import { IBusinessType } from '@/models/business';

@Component({
  components: {
    Surface,
    Typography,
    FilledButton,
    CoinSettings,
    BirthdayCoinSettings,
    SpecialCoinOfferImage,
    DiscountOffer,
    ExternalLink,
    TagSpecialCoin,
    TagBirthday,
    ImageSpecialCoinPreview,
    OfferTypeTag,
    OfferImageUploadCreation
  }
})
export default class OverviewSidebar extends Vue {
  @Prop() offer!: any;
  @Prop() errors!: Array<string>;
  @Prop({ default: () => [] }) locations?: Array<ILocation>;
  @Prop() loading?: boolean;
  @Prop() offerLink?: string;

  activeTab = 0;

  data = {
    imageId: '',
    imageLink: ''
  };

  createSpecialCoin() {
    this.$emit('submit');
  }

  handlePreview() {
    this.$emit('preview');
  }

  @Watch('data', { deep: true })
  changedData(data: any) {
    this.$emit('input', data);
  }

  onUploadImage(response: any) {
    this.data.imageId = response.id;
    this.data.imageLink = response.link;
    this.$emit('clearError', 'offer-image');
  }

  onDeleteImage() {
    this.data.imageId = '';
    this.data.imageLink = '';
    this.$emit('clearError', 'offer-image');
  }

  get business() {
    return this.$store.getters['business/getBusinessState'];
  }

  get tPrefix() {
    return 'offers.form';
  }

  get title() {
    if (!this.offer.title)
      return this.$t(
        `${this.tPrefix}.titleOverviewPlaceholder.${this.offer.specialType}`
      );

    return this.offer.title;
  }

  get businessName() {
    return this.business.name;
  }

  get businessLogo() {
    return this.business.logo.publicPath.small;
  }

  get businessAddress() {
    if (this.business.type === IBusinessType.ONLINE)
      return this.business.website;

    return this.business.address;
  }

  get isBirthday() {
    return this.offer.specialType === SpecialOfferTypeEnum.BIRTHDAY;
  }
}
